export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';
export const TERTIARY = 'tertiary';
export const QUARTERNARY = 'quarternary';
export const QUINARY = 'quinary';
export const DANGER = 'danger';

export const BUTTON_STYLES = [PRIMARY, SECONDARY, TERTIARY, QUARTERNARY, QUINARY, DANGER];
